<!-- <app-survay-header></app-survay-header>
<div class="Main-Cont">
    <div class="text-center ques-cont">
        <div>
            <img src="../../../../../assets/image/m@2x.png" alt="" />
        </div>
        <div class="text-primary fw-bold fs-4 survey-head">
            This is a Demographic survey
        </div>
        <div class="text-dark fs-6 survey-head fw-bold">
            You will be asked to complete
            your profile firstly then after you will be redirected to the main survey.
        </div>
        <div class="text-muted fs-6 survey-head fw-bold">
            No rewards are given on 
            completing profile.
        </div>
        <div class="mt-4">
            <img class="Image-Section" src="../../../../../assets/image/group-2@2x.png" alt="" />
        </div>
    </div>
    <div class="footer">
        <div class="text-end">
            <button class="btn btn-primary" (click)="proceed()">Proceed</button>
        </div>
    </div>
    
</div> -->

<!-- Dyanmic Template -->

<!-- <app-survay-header></app-survay-header> -->
<div class="Mid-temp-section">
    <div *ngIf="screenTemplate" [innerHTML]="screenTemplate">
    </div>
</div>

<div *ngIf="temp_deatils && temp_deatils['isTermandCond']" class="footer">
    <div class="termandCondition">
        <input type="checkbox" id="termsAndCondition" [(ngModel)]="isTermsAndConditionAccept"/>
        I accept the
        <span style="cursor: pointer; margin-left: 5px;" (click)="openPopup()">
            terms and conditions
        </span>

    </div>
    <div *ngIf="temp_deatils && temp_deatils['footer_btn_text']">
        <button class="btn btn-primary proceedBtn" (click)="proceed()">{{temp_deatils && temp_deatils['footer_btn_text']}}</button>
    </div>
</div>

<div *ngIf="temp_deatils && !temp_deatils['isTermandCond']" class="footer footer-2">
    <div *ngIf="temp_deatils && temp_deatils['footer_btn_text']" class="text-end">
        <button class="btn btn-primary proceedBtn" (click)="proceed()">{{temp_deatils && temp_deatils['footer_btn_text']}}</button>
    </div>
</div>


<div *ngIf="isTermAndConditionOpen" class="overlay">
    <div class="popup">
        <div class="close_popup">
            <img (click)="closePopup()" src="../../../assets/image/close_black.png" alt="close">
        </div>
        <div class="term-heading text-dark fw-bold">Terms and conditions</div>

        <div class="text-muted text-start fw-bold">
            GoldVIP Technology Solutions Private Limited (hereinafter “GoldVIP” or “Crownit”) is a market
            research agency registered with the Market Research Society of India. Crownit conducts
            consumer market research surveys on products and services for its Clients. Only eligible
            audiences, whose city, age, gender match to the survey’s requirement, have a chance to
            complete the survey. Further the responses required in a given survey are also limited by count
            and time, hence you may not qualify for a given survey

        </div>

        <div class="text-muted text-start my-2 fw-bold">
            By agreeing to answer a survey through the Meesho’s Crownit link, you hereby agree that:
        </div>

        <div class="text-muted text-start my-2 fw-bold">
            1. Your responses are subject to quality checks and you may not receive the reward in case of
            rejection of the responses due to quality reasons. Some of the instances where your response
            may be rejected are:

            <div class="ms-4">
                <div class="text-muted text-start my-1">
                    a. Speeding through the questions and answers.
                </div>

                <div class="text-muted text-start my-1">
                    b. Inattentive responses to questions.
                </div>

                <div class="text-muted text-start my-1">
                    c. Irrelevant or gibberish or duplicate responses to questions which need open-end
                    responses to be typed in.
                    
                </div>

                <div class="text-muted text-start my-1">
                    d. Duplicate IP (more than one response coming in from the same IP address).
                </div>

            </div>
        </div>


        <div class="text-muted text-start my-2 fw-bold">
            2. The process of quality checks may take a few days ranging from two days to two weeks.

        </div>


        <div class="text-muted text-start my-2 fw-bold">
            3. Meesho is responsible for distributing your reward for your participation in any survey
        </div>


        <div class="text-muted text-start my-2 fw-bold">
            4. You will not disseminate information learnt during a survey on any private or public forum
        </div>


        <div class="text-muted text-start my-2 fw-bold">
            5. Usually surveys are run on Crownit’s own survey builder platform, however there can be
            surveys where you are directed to a Client page. However, your personally identifiable
            information is not passed outside Crownit’s own secure servers.

        </div>




    </div>

</div>